import { createClient } from '@supabase/supabase-js';

// Supabase configuration
// Uses environment variables for security and flexibility
// Fallback to hardcoded values for backwards compatibility
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://ygqlejrhuukkrvgrsrjw.supabase.co';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InlncWxlanJodXVra3J2Z3Jzcmp3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjE2Nzk1NjMsImV4cCI6MjA3NzI1NTU2M30.oOgBv9QH12jolkmCtqnTe9qAIDrvHcHf5Fy4Bu1eaJ0';

// Validate configuration
if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase configuration. Please check your environment variables.');
}

// Create Supabase client
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true  // Enable automatic URL detection for OAuth
  }
});

export default supabase;
